
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AccidentTravail from '@/extend/classes/AccidentTravail';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeAccidentTravail' })

export default class storeAccidentTravail extends VuexModule {
  // States
  private reccords: AccidentTravail[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get accidentTravailLoading (): boolean {
    return this.dataLoading;
  }
  private get accidentTravailRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get accidentTravailLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewAccidentTravail() {
    return (): AccidentTravail => { 
      return this.getAccidentTravail(0, true);
    }
  }

  
  public get getAccidentTravail () {
    return (id: number, canCreate = false): AccidentTravail => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id AccidentTravail can't be 0")
        return new AccidentTravail();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new AccidentTravail();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            AccidentTravail.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromAccidentTravail(data.reccords[0] as AccidentTravail);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listAccidentTravail (): AccidentTravail[] {
    return this.reccords;
  }

  public get listConfigAccidentTravail (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAccidentTravailRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAccidentTravailClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAccidentTravailLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAccidentTravailLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(AccidentTravail.fromJson(reccord as AccidentTravail));
    })
    AccidentTravail.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAccidentTravailConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAccidentTravailCreated (obj: AccidentTravail): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAccidentTravail(obj)) {
          api.fromAccidentTravail(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAccidentTravail(obj)) {
            api.fromAccidentTravail(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAccidentTravailUpdated (obj: AccidentTravail): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAccidentTravail(obj)) {
          api.fromAccidentTravail(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAccidentTravailDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAccidentTravail (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.accidentTravailRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAccidentTravail(this.accidentTravailCreated, this.accidentTravailUpdated, this.accidentTravailDeleted);
          this.mAccidentTravailRegistered();
        } else {
          setTimeout(() => resolve(this.registerAccidentTravail(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.accidentTravailLoading && !this.accidentTravailLoaded) {
          this.mAccidentTravailLoading(true);
          return AccidentTravail.list(filter)
            .then((data: ListData) => {
              this.mAccidentTravailLoaded(data);
              this.mAccidentTravailLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAccidentTravail (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.accidentTravailLoading) {
        this.mAccidentTravailLoading(true);
        return AccidentTravail.list(filter)
          .then((data: ListData) => {
            this.mAccidentTravailLoaded(data);
            this.mAccidentTravailLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createAccidentTravail (obj: AccidentTravail): Promise<AccidentTravail> {
    return new Promise((resolve, reject) => {
      return AccidentTravail.fromJson(obj).createForStoreAccidentTravail()
        .then((reccords) => {
          this.mAccidentTravailCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateAccidentTravail (obj: AccidentTravail): Promise<AccidentTravail> {
    return new Promise((resolve, reject) => {
      return AccidentTravail.fromJson(obj).updateForStoreAccidentTravail()
        .then((reccords) => {
          this.mAccidentTravailUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteAccidentTravail (obj: AccidentTravail): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return AccidentTravail.fromJson(obj).deleteForStoreAccidentTravail()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mAccidentTravailDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private accidentTravailCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAccidentTravailConfigUpdated(config)
    const obj = objConfig.obj as AccidentTravail;
    this.mAccidentTravailCreated(AccidentTravail.fromJson(obj));
  }

  @Action
  private accidentTravailUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAccidentTravailConfigUpdated(config)
    const obj = objConfig.obj as AccidentTravail;
    this.mAccidentTravailUpdated(AccidentTravail.fromJson(obj));
  }

  @Action
  private accidentTravailDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as AccidentTravail;
    this.mAccidentTravailDeleted(obj.id);
  }
}
